import { SfLog } from '@app/adapters/logger'
import sfetch from '@app/utils/sfetch'
import { onDocumentEvent } from '@app/utils/domHelpers'

const loadNextPeriodDetails = async (e) => {
  const selectElement = e.target
  const selectedOption = selectElement.querySelector('option:checked')
  const currentLedgerId = selectElement?.dataset?.currentLedgerId
  const url = selectedOption?.dataset?.url

  if (url && currentLedgerId) {
    try {
      const responseText = await sfetch.html(url, {
        method: 'POST',
        body: {
          current_ledger_id: currentLedgerId,
        },
      })

      const detailSection = document.querySelector('.detail-section')

      window.requestAnimationFrame(() => {
        detailSection.innerHTML = ''
        detailSection.insertAdjacentHTML('afterbegin', responseText)
      })
    } catch (e) {
      SfLog.error('Error during loading next period details', {
        error: e,
      })
    }
  }
}

onDocumentEvent(
  document,
  'change',
  '[data-behaviour~="details-period-select"]',
  loadNextPeriodDetails
)
